import { render, staticRenderFns } from "./DirectorReview.vue?vue&type=template&id=3e66403e&scoped=true&"
import script from "./DirectorReview.vue?vue&type=script&lang=js&"
export * from "./DirectorReview.vue?vue&type=script&lang=js&"
import style0 from "./DirectorReview.vue?vue&type=style&index=0&id=3e66403e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66403e",
  null
  
)

export default component.exports